import {Field, ErrorMessage, useField} from 'formik';
import styled from 'styled-components';

import {FieldMargin} from '../../_old/FieldHelpers/FieldContainers';
import {FormError} from '../../_old/FieldHelpers/FormError';
import {scToTwColour} from '../../theme';

import {Toggleable} from './Toggleable';

import type {FieldProps} from 'formik';

type Props = {
  children: React.ReactNode;
  type: 'radio' | 'checkbox';
  name: string;
  items: ToggleableItem[];
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  className?: string;
};
export function ToggleableSet(props: Props): React.JSX.Element {
  return (
    <FieldMargin>
      <Label className="small-upper">{props.children}</Label>

      <Wrapper className={props.className}>
        {props.items.map((item) => (
          <Field
            key={item.value}
            name={props.name}
            value={item.value}
            type={props.type}
          >
            {({field}: FieldProps) => (
              <StyledToggleable
                {...props.inputProps}
                {...field}
                type={props.type}
                title={item.title}
              >
                {item.label}
              </StyledToggleable>
            )}
          </Field>
        ))}
      </Wrapper>
      <ErrorMessage name={props.name} component={FormError} />
    </FieldMargin>
  );
}
export function ToggleableSet2(props: Props): React.JSX.Element {
  const [, meta] = useField(props.name);

  return (
    <FieldMargin>
      <Label className="small-upper">{props.children}</Label>

      <Wrapper className={props.className}>
        {props.items.map((item) => (
          <Field
            key={item.value}
            name={props.name}
            value={item.value}
            type={props.type}
          >
            {({field}: FieldProps) => (
              <StyledToggleable
                {...props.inputProps}
                {...field}
                type={props.type}
                title={item.title}
              >
                {item.label}
              </StyledToggleable>
            )}
          </Field>
        ))}
      </Wrapper>

      {meta.error &&
        meta.touched &&
        // @ts-expect-error formik zod not sure idk
        meta.error._errors?.map((error) => (
          <FormError key={error}>{error}</FormError>
        ))}
    </FieldMargin>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: -0.25em;
`;
const StyledToggleable = styled(Toggleable)`
  margin: 0.25em;
  padding: 0.4rem 0.6rem;
`;
const Label = styled.p`
  position: relative;
  font-size: 0.875rem;
  color: ${scToTwColour('theme.colours.slate11')};
`;

export type ToggleableItem = {
  value: string;
  label: React.ReactNode;
  title?: string;
};
